<template>
  <div
    class="p-5 rounded bg-gray-100 flex flex-col justify-between"
    v-if="form !== undefined"
  >
    <div class="">
      <h2 class="font-bold pb-5" v-text="i18n.billing_contact"></h2>
      <div class="text-sm">
        <div v-text="name"></div>
        <div v-text="company" v-if="isCompany"></div>
        <div v-text="vat" v-if="isCompany"></div>
        <div v-text="street"></div>
        <div><span v-text="zipcode"></span> <span v-text="city"></span></div>
        <div v-text="state"></div>
        <div v-text="country"></div>
      </div>
    </div>
    <div class="flex justify-center pt-5">
      <ranch-button
        :label="i18n.modify"
        @click="updateContactData"
        :icon="['fas', 'pencil-alt']"
        action="action-secondary"
      ></ranch-button>
    </div>
  </div>
</template>

<script>
export default {
  props: [],
  components: {},
  mixins: [],
  data: function () {
    return {};
  },
  methods: {
    updateContactData() {
      this.$emit("to-modify", this.account);
    },
  },
  computed: {
    i18n() {
      if (this.$store.state.safe.i18n !== undefined) {
        return this.$store.state.safe.i18n.new_refill.billing;
      }

      return undefined;
    },
    account() {
      return this.$store.state.account.contact;
    },
    form() {
      return this.$store.state.safe.form;
    },
    hasUpdatedData() {
      return this.form !== undefined;
    },
    name() {
      if (this.hasUpdatedData) {
        return this.form.firstname + " " + this.form.lastname;
      }

      return this.account.firstname + " " + this.account.lastname;
    },
    company() {
      if (this.hasUpdatedData) {
        return this.form.company;
      }

      return this.account.company;
    },
    vat() {
      if (this.hasUpdatedData) {
        return this.form.vat;
      }

      return this.account.vat;
    },
    street() {
      if (this.hasUpdatedData) {
        return this.form.add_main;
      }

      return this.account.add_main;
    },
    zipcode() {
      if (this.hasUpdatedData) {
        return this.form.add_zip;
      }

      return this.account.add_zip;
    },
    city() {
      if (this.hasUpdatedData) {
        return this.form.add_city;
      }

      return this.account.add_city;
    },
    state() {
      if (this.hasUpdatedData) {
        return this.form.add_state;
      }

      return this.account.add_state;
    },
    country() {
      if (this.hasUpdatedData) {
        return this.form.add_country.name;
      }

      return this.account.add_country.name;
    },
    isCompany() {
      if (this.hasUpdatedData) {
        return this.form.invoice_to == 1;
      }

      return this.account.invoice_to == 1;
    },
  },
  mounted() {},
};
</script>

<style></style>
